
    import './styles.scoped.css';
    export default {
  "calendar": "awsui_calendar_mgja0_1jtcl_149",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_mgja0_1jtcl_1",
  "root": "awsui_root_mgja0_1jtcl_172",
  "wide": "awsui_wide_mgja0_1jtcl_206",
  "focus-lock": "awsui_focus-lock_mgja0_1jtcl_213",
  "trigger-wrapper": "awsui_trigger-wrapper_mgja0_1jtcl_217",
  "trigger-flexbox": "awsui_trigger-flexbox_mgja0_1jtcl_221",
  "calendar-container": "awsui_calendar-container_mgja0_1jtcl_225",
  "one-grid": "awsui_one-grid_mgja0_1jtcl_228",
  "calendar-header": "awsui_calendar-header_mgja0_1jtcl_232",
  "calendar-header-months-wrapper": "awsui_calendar-header-months-wrapper_mgja0_1jtcl_238",
  "calendar-header-month": "awsui_calendar-header-month_mgja0_1jtcl_238",
  "calendar-next-month-btn": "awsui_calendar-next-month-btn_mgja0_1jtcl_257",
  "calendar-prev-month-btn": "awsui_calendar-prev-month-btn_mgja0_1jtcl_260",
  "first-grid": "awsui_first-grid_mgja0_1jtcl_264",
  "second-grid": "awsui_second-grid_mgja0_1jtcl_265",
  "date-and-time-container": "awsui_date-and-time-container_mgja0_1jtcl_269",
  "date-and-time-wrapper": "awsui_date-and-time-wrapper_mgja0_1jtcl_275",
  "footer": "awsui_footer_mgja0_1jtcl_282",
  "has-clear-button": "awsui_has-clear-button_mgja0_1jtcl_291",
  "footer-button-wrapper": "awsui_footer-button-wrapper_mgja0_1jtcl_300",
  "icon-wrapper": "awsui_icon-wrapper_mgja0_1jtcl_307",
  "label": "awsui_label_mgja0_1jtcl_312",
  "label-enabled": "awsui_label-enabled_mgja0_1jtcl_317",
  "label-text": "awsui_label-text_mgja0_1jtcl_321",
  "label-token-nowrap": "awsui_label-token-nowrap_mgja0_1jtcl_326",
  "mode-switch": "awsui_mode-switch_mgja0_1jtcl_330",
  "dropdown": "awsui_dropdown_mgja0_1jtcl_334",
  "dropdown-content": "awsui_dropdown-content_mgja0_1jtcl_356",
  "start-date-input": "awsui_start-date-input_mgja0_1jtcl_365",
  "start-time-input": "awsui_start-time-input_mgja0_1jtcl_366",
  "end-date-input": "awsui_end-date-input_mgja0_1jtcl_367",
  "end-time-input": "awsui_end-time-input_mgja0_1jtcl_368",
  "validation-section": "awsui_validation-section_mgja0_1jtcl_372",
  "validation-error": "awsui_validation-error_mgja0_1jtcl_376",
  "clear-button": "awsui_clear-button_mgja0_1jtcl_380",
  "apply-button": "awsui_apply-button_mgja0_1jtcl_384",
  "cancel-button": "awsui_cancel-button_mgja0_1jtcl_388",
  "calendar-aria-live": "awsui_calendar-aria-live_mgja0_1jtcl_392"
};
  